import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getRemotedbUrl, i18nIntl, isNotEmpty } from '../../lib/ep';
import { useCSS } from '../../lib/hooks';

import ActionLink from '../builder/ActionLink';
import { SquaredButton } from '../builder/ActionButton';
import Spinner from '../builder/Spinner';
import Tooltip from '../builder/Tooltip';

const Wrapper = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	return (
		<>
			<header class="certificates_list_header">
				<div class="header_c">
					<ActionLink
						_href="https://www.easypromosapp.com/"
						_target="_blank"
						_class={{ other:'logo' }}
						autotranslate={false}
					><span class="visually_hidden">easypromos</span></ActionLink>

					<p class="slogan">{i18n("The leading platform for social media giveaways")}</p>
				</div>
			</header>

			<section class="element_list">
				<article class="section_contents">
					<h1 class="bordered_element">{i18n("Certificates of validity")}</h1>

					<p>
						<FormattedMessage
							id="Public list of certificates of all sweepstakes completed by {ep}"
							values={{
								ep:<strong style={{ color:'var(--link-color)' }}>Easypromos</strong>,
							}}
						/>
					</p>
				</article>

				{props.children}
			</section>
		</>
	)
}

const SweepsCertificateList = ({ sweeps, ...props }) => {
	useCSS('comp/certificate_list.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ certificates, setCertificates ] = useState(sweeps);
	const [ page, setPage ] = useState(1);
	const [ loading, setLoading ] = useState(false);
	const [ display_view_more, setDisplayViewMore ] = useState(true);

	const fetchCertificates = (page) => {
		setLoading(true);

		$.get(getRemotedbUrl(`/sweeps/certificates/${page}`), (result) => {
			const new_certificates = result?.certificates ?? [];

			if(new_certificates.length > 0) {
				setCertificates(certificates.concat(new_certificates));
				setPage(result.lastpage);
			} else {
				setDisplayViewMore(false);
			}

			setLoading(false);
		}, 'JSON');
	};

	if(certificates.length == 0) {
		return (
			<Wrapper
				intl={props.intl}
			>
				<p>{i18n("No certificates match the search query.")}</p>
			</Wrapper>
		)
	}

	return (
		<Wrapper
			intl={props.intl}
		>
			<div class="emulated_table">
				<div class="thead">
					<div>
						<div />

						<div>{i18n("Reference")}</div>

						<div>{i18n("Finalists")}</div>

						<div />
					</div>
				</div>
		
				<div class="tbody">

					{certificates.map((sweep, s) => {
						const link = (isNotEmpty(sweep, 'link_certificate')) ? sweep.link_certificate : `${window.sweeps_url}c/${sweep.id}`;
						return (
							<div key={`certificate_${s}`} class="row">
								<strong class="date_col">{sweep.date}</strong>

								<span class="id_col">{i18n("ID")}: {sweep.id}</span>

								<span class="type_col">{sweep.type}</span>

								<div class="main_col">
									<strong class="sweeps_title" dangerouslySetInnerHTML={{ __html:sweep.ref }} />

									<p class="clamped_multiline">{sweep.title}</p>
								</div>

								<div class="counter_col">
									<span class="is_short is_label">{i18n("Finalists")}:</span>
									{sweep.finalists}
								</div>

								<div class="actions_col">
									<ActionLink
										_href={link}
										_target="_blank"
										_class={{ other:'is_short' }}
									>View certificate</ActionLink>

									<SquaredButton
										_href={link}
										icon='knk-visible'
										_target="_blank"
										_class={{ other:'is_wide' }}
										tooltip={<Tooltip
											with_icon={false}
											position='top'
										>View certificate</Tooltip>}
									/>
								</div>
							</div>
						)
					})}
				</div>
			</div>

			{(display_view_more) && (
				<div class="gui_pos_rel gui_not_in_top_big">
					{(loading === false) ? (
						<ActionLink
							type="save"
							onClick={(e, cb) => fetchCertificates(parseInt(page) + 1, cb)}
						>View More</ActionLink>
					) : (
						<Spinner
							is_transparent={false}
							_class={{ other:'gui_pos_rel_important' }}
						/>
					)}
				</div>
			)}
		</Wrapper>
	)
};

export default injectIntl(SweepsCertificateList);